module.exports = __webpack_public_path__ + "img/pay2home-poweredby.0f309c71.png";